import { render, staticRenderFns } from "./spacer.vue?vue&type=template&id=221cd01c&scoped=true&"
import script from "./spacer.vue?vue&type=script&lang=js&"
export * from "./spacer.vue?vue&type=script&lang=js&"
import style0 from "./spacer.vue?vue&type=style&index=0&id=221cd01c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221cd01c",
  null
  
)

export default component.exports